/**
 * トップ .homeStaff：サムネクリックでメインの .is-active を同期
 * - document キャプチャで委譲（Swup の document リスナーより先に import して登録順を最優先にする）
 * - リスナーはページ遷移後も DOM 差し替えに不要なため「1回だけ」登録（destroy の取り違えで反応しなくなるのを防ぐ）
 */
const THUMB_SEL = '.homeStaff-content-thumb-list-item[data-home-staff-index]';
const MAIN_SEL = '.homeStaff-content-main-list-item[data-home-staff-index]';

function setActiveForRoot(root, index) {
  var thumbs = root.querySelectorAll(THUMB_SEL);
  var mains = root.querySelectorAll(MAIN_SEL);
  if (!thumbs.length || !mains.length) {
    return;
  }
  thumbs.forEach(function (el) {
    var i = parseInt(el.getAttribute('data-home-staff-index'), 10);
    var active = i === index;
    el.classList.toggle('is-active', active);
    el.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
  mains.forEach(function (el) {
    var i = parseInt(el.getAttribute('data-home-staff-index'), 10);
    el.classList.toggle('is-active', i === index);
  });
  root.dispatchEvent(
    new CustomEvent('homeStaff:active-changed', {
      bubbles: true,
      detail: { root: root, index: index },
    })
  );
}

function onDocumentClickCapture(ev) {
  var item = ev.target.closest(THUMB_SEL);
  if (!item) {
    return;
  }
  var root = item.closest('.homeStaff');
  if (!root) {
    return;
  }
  var idx = parseInt(item.getAttribute('data-home-staff-index'), 10);
  if (Number.isNaN(idx)) {
    return;
  }
  setActiveForRoot(root, idx);
}

function onDocumentKeydownCapture(ev) {
  if (ev.key !== 'Enter' && ev.key !== ' ') {
    return;
  }
  var item = ev.target.closest(THUMB_SEL);
  if (!item) {
    return;
  }
  var root = item.closest('.homeStaff');
  if (!root || !root.contains(ev.target)) {
    return;
  }
  var idx = parseInt(item.getAttribute('data-home-staff-index'), 10);
  if (Number.isNaN(idx)) {
    return;
  }
  ev.preventDefault();
  setActiveForRoot(root, idx);
}

function bindHomeStaffThumbSelectOnce() {
  if (window.__homeStaffThumbDocBound) {
    return;
  }
  window.__homeStaffThumbDocBound = true;
  document.addEventListener('click', onDocumentClickCapture, true);
  document.addEventListener('keydown', onDocumentKeydownCapture, true);
}

function bootHomeStaffThumbSelect() {
  bindHomeStaffThumbSelectOnce();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootHomeStaffThumbSelect);
} else {
  bootHomeStaffThumbSelect();
}

document.addEventListener('swup:replaced', bootHomeStaffThumbSelect);
